"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var InvoiceTax_1 = require("./InvoiceTax");
var CreateInvoiceLine = /** @class */ (function () {
    function CreateInvoiceLine(invoice, json) {
        this.id = null;
        this.productId = null;
        this.parentProductId = null;
        this.productUnit = 'unit';
        // This refers to retail price
        this.price = 0;
        this.costPerUnit = 0;
        this.quantity = 1;
        this.total = 0;
        this.batches = [];
        this.taxes = [];
        if (json) {
            Object.assign(this, json);
            this.costPerUnit = Math.round(this.total / (this.quantity || 1));
        }
        this.invoice = invoice;
        this.observeForTaxes();
    }
    CreateInvoiceLine.prototype.setQuantity = function (quantity) {
        this.quantity = quantity;
        if (quantity) {
            this.costPerUnit = Math.round(this.total / quantity);
        }
        else {
            this.costPerUnit = 0;
        }
    };
    CreateInvoiceLine.prototype.setQuantityReceived = function (quantityReceived) {
        this.quantityReceived = quantityReceived;
    };
    CreateInvoiceLine.prototype.setPreviousCostPerUnit = function (costPerUnit) {
        this.previousCostPerUnit = costPerUnit;
    };
    CreateInvoiceLine.prototype.setTotal = function (total) {
        this.total = Math.round(total);
        if (total) {
            this.costPerUnit = Math.round(total / (this.quantity || 1));
        }
    };
    CreateInvoiceLine.prototype.addBatch = function (newBatch) {
        var existingBatchIndex = this.batches.findIndex(function (existingBatch) {
            return existingBatch.batchNumber.toLowerCase() === newBatch.batchNumber.toLowerCase();
        });
        if (existingBatchIndex >= 0) {
            this.batches[existingBatchIndex].quantity += newBatch.quantity;
        }
        else {
            this.batches = __spread(this.batches, [newBatch]);
        }
    };
    CreateInvoiceLine.prototype.removeBatch = function (index) {
        this.batches.splice(index, 1);
    };
    CreateInvoiceLine.prototype.setLot = function (lot) {
        this.lot = lot;
    };
    CreateInvoiceLine.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    Object.defineProperty(CreateInvoiceLine.prototype, "taxTotal", {
        get: function () {
            return this.taxes.reduce(function (total, tax) { return total + tax.amount; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoiceLine.prototype, "batchQuantitySum", {
        get: function () {
            return this.batches.reduce(function (prev, curr) { return prev + curr.quantity; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * if total or invoice.taxGroupId is changed, recalculate taxes
     */
    CreateInvoiceLine.prototype.observeForTaxes = function () {
        var _this = this;
        mobx_1.observe(this, function (change) {
            if (change.name === 'total') {
                _this.reAssignTaxes();
            }
        });
        mobx_1.observe(this.invoice, function (change) {
            if (change.name === 'taxGroup') {
                _this.reAssignTaxes();
            }
        });
    };
    CreateInvoiceLine.prototype.reAssignTaxes = function () {
        var _this = this;
        if (this.invoice.taxGroup) {
            this.taxes = this.invoice.taxGroup.taxLines.map(function (taxLine) { return new InvoiceTax_1.CreateInvoiceTax(taxLine.taxId, (taxLine.percent / 100) * _this.total); });
        }
        else {
            this.taxes = [];
        }
    };
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "invoice", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "productName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "productId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "productUnit", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "costPerUnit", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "previousCostPerUnit", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "quantity", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "quantityReceived", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "total", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "batches", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "isBatchTracked", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "taxes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceLine.prototype, "lot", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "setQuantity", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "setQuantityReceived", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "setPreviousCostPerUnit", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "setTotal", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "addBatch", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "removeBatch", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "setLot", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "setNotes", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoiceLine.prototype, "taxTotal", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoiceLine.prototype, "batchQuantitySum", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceLine.prototype, "reAssignTaxes", null);
    return CreateInvoiceLine;
}());
exports.CreateInvoiceLine = CreateInvoiceLine;
//# sourceMappingURL=InvoiceLine.js.map